import { createUseStyles } from 'react-jss';
import orange from '@material-ui/core/colors/orange';

export const useStyles = createUseStyles({
  Title: {
    color: '#424242',
    borderBottom: '1px solid grey',
    backgroundColor: '#f1f1f1',
    padding: '5px',
    fontSize: '20px',
    marginBottom: '0em',
  },
  Container: {
    marginLeft: '25px',
  },
  Field: {
    display: 'grid',
    paddingRight: '10px',
    width: '100%',
  },
  Bold: {
    fontWeight: 'bold',
  },
  UpperCase: {
    textTransform: 'uppercase',
  },
  TemplateDropdown: {
    width: '250px',
    marginRight: '24px',
  },
  TemplateButton: {
    marginRight: '12px',
    marginBottom: '7px',
  },
  ArchivedLabel: {
    marginLeft: '20px',
    textAlign: 'center',
    fontSize: '20px',
  },
  iconWrapper: {
    display: 'inline-flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '40px',
    width: '40px',
    fontSize: '20px',
    color: 'red',
    marginBottom: '5px',
  },
  EndAdornmentIcon: {
    fontSize: 16,
  },
  errorIcon: {
    color: orange[400],
  },
  TableLayoutAuto: {
    '& table': {
      tableLayout: 'auto',
    },
    '& tr:nth-child(odd) td': {
      borderBottom: 0,
    },
  },
});
